import React = require('react');
import { Col, Modal, Row } from 'react-bootstrap';

export const DeclineQuote = ({ showDeclineModal }) => {

  const onHideModal = () => {
    return null;
  }
  return (
    <Modal show={showDeclineModal} onHide={onHideModal} keyboard={false} backdrop={'static'}>
      <Modal.Header closeButton={false}>
        <Modal.Title>We are Sorry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <p>Unfortunately, we are unable to continue.</p>
            <p>Please call us on 0333 234 9913, lines are open 9am until 6pm from Monday to Friday (closed on
              weekends) to discuss this further.</p>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}
